import * as Sentry from '@sentry/browser'

/**
 * Tool-usage telemetry — sends a Sentry breadcrumb with `category: 'tool'`.
 * Sentry breadcrumbs are attached to subsequent error reports, so we get
 * tool-usage signals "for free" inside error context. They also appear in
 * Sentry's session-replay if enabled.
 *
 * Not full product analytics (no PostHog / Mixpanel pipeline in Tunasong
 * yet) — this is the minimum-viable signal that unblocks "which tools get
 * used" measurement via Sentry's existing dashboard.
 *
 * @example
 *   addToolBreadcrumb('opened', { tool: 'mode-lab' })
 *   addToolBreadcrumb('action', { tool: 'reharm-lab', action: 'substitution-applied', technique: 'tritone-sub' })
 */
export const addToolBreadcrumb = (
  action: string,
  data?: Record<string, string | number | boolean>
): void => {
  Sentry.addBreadcrumb({
    category: 'tool',
    type: 'user',
    level: 'info',
    message: action,
    data,
  })
}
